<template>
  <div class="confirmation-block-root">
    <div class="title">
      <slot name="title" />
    </div>

    <div class="coin-amount-row">
      <slot name="description" />
    </div>

    <div class="additional-content-row">
      <slot name="additional-content" />
    </div>
  </div>
</template>

<script>
export default {}
</script>

<style scoped lang="scss">
.confirmation-block-root {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  border-radius: 10px;
  border: 1px solid var(--bg-3);
  background: var(--bg-2);
  padding: 40px;
}

.title {
  font-size: 14px;
  font-weight: 500;
  color: var(--text-6);
}

.coin-amount-row {
  width: 400px;
  font-size: 28px;
  font-weight: 600;
  color: var(--text-1);
  word-wrap: break-word;
  text-align: center;
}

.additional-content-row {
  margin-top: 10px;
}
</style>
